import type { PresetColour } from '../../gql';

import { randBoolean, randNumber } from '@ngneat/falso';

import { mockMasterColour } from '../mockMasterColour';

const mockPresetColour = (overwrite?: Partial<PresetColour>): PresetColour => ({
    colourPositionIndex: randNumber({ min: 0, max: 5 }),
    masterColour: randBoolean() ? mockMasterColour() : null,
    ...overwrite,
});

export { mockPresetColour };
